export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export interface CompanyCommissionRateDto {
  id: string;
  companyId: string;
  agencyId: string;
  stateCode: string;
  policyType: string | null;
  agencyDirect: string | null;
  billCode: string | null;
  minAge: number | null;
  maxAge: number | null;
  geoTier: number | null;
  marketType: string | null;
  businessType: string | null;
  planType: string | null;
  groupType: string | null;
  writingCompanyId: string | null;
  rate: number | null;
  effectiveDate: Date | null;
  county: string | null;
  zipCode: string | null;
  notes: string | null;
}

export const createEmptyCommissionRate = (companyId: string): CompanyCommissionRateDto => ({
  id: EMPTY_GUID,
  companyId,
  agencyId: '',
  stateCode: '',
  policyType: null,
  agencyDirect: null,
  billCode: null,
  minAge: null,
  maxAge: null,
  geoTier: null,
  marketType: null,
  businessType: null,
  planType: null,
  groupType: null,
  writingCompanyId: null,
  rate: null,
  effectiveDate: null,
  county: null,
  zipCode: null,
  notes: null,
});
